<mat-toolbar class="subtitulo">Exportação de dados do Beneficiário/Familiar</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form [formGroup]="form" role="form">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="200px" fxLayoutGap="20px">
                    <input matInput name="cpf" placeholder="CPF:" formControlName="cpf"
                        [textMask]="{mask: mascaraCpf}">
                </mat-form-field>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input matInput name= "dataInicioEntrada"
                            [matDatepicker]="dataInicioEntrada" 
                            placeholder="Data Início Entrada" 
                            formControlName="dataInicioEntradaInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioEntrada"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioEntrada></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" >
                    <input matInput name="dataFimEntrada"
                            [matDatepicker]="dataFimEntrada" 
                            placeholder="Data Fim Entrada" 
                            formControlName="dataFimEntradaInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFimEntrada"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimEntrada></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input matInput name= "dataInicioVigencia"
                           [matDatepicker]="dataInicioVigencia" 
                           placeholder="Data Início Vigência" 
                           formControlName="dataInicioVigenciaInstituicao"
                           (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioVigencia"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioVigencia></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px">
                    <input matInput name="dataFimVigencia"
                            [matDatepicker]="dataFimVigencia" 
                            placeholder="Data Fim Vigência" 
                            formControlName="dataFimVigenciaInstituicao"
                            (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataFimVigencia"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimVigencia></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex= "200px" fxLayoutGap="20px" floatLabel="always">
                    <mat-label>Situação:</mat-label>
                    <mat-select formControlName="ativo" name="situacao" placeholder="Ambos">
                        <mat-option [value]="null">Ambos</mat-option>
                        <mat-option [value]="true">Ativo</mat-option>
                        <mat-option [value]="false">Inativo</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="33%" fxLayoutGap="20px">
                    <input matInput name="beneficiario" placeholder="Beneficário:" formControlName="beneficiario" (input)="sincronizarMatriculaSecretaria()">
                </mat-form-field>
                <mat-form-field fxFlex="33%" fxLayoutGap="20px">
                    <input matInput name="nomeMae" placeholder="Mãe do beneficiário:" formControlName="nomeMae">
                </mat-form-field>
                <mat-form-field fxFlex="33%" fxLayoutGap="20px">
                    <input matInput name="nomePai" placeholder="Pai do beneficiário:" formControlName="nomePai">
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlexFill>
                <mat-form-field fxLayoutGap="20px" fxFlex="33%">
                    <mat-label>Programa:</mat-label>
                    <mat-select formControlName="programa">
                        <mat-option [value]="null">Selecione</mat-option>
                        <mat-option *ngFor="let o of compoPrograma" [value]="o.id">
                                {{o.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field fxFlexOffset="20px" fxFlex="33%">
                    <mat-label>Projeto:</mat-label>
                    <mat-select formControlName="projeto">
                        <mat-option [value]="null">Selecione</mat-option>
                        <mat-option *ngFor="let o of compoProjeto" [value]="o.id">
                                {{o.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>   
                <mat-form-field fxFlexOffset="20px" fxFlex="33%">
                    <mat-label>Unidade:</mat-label>
                    <mat-select formControlName="unidade" (selectionChange)="sincronizarMatriculaSecretaria()">
                        <mat-option [value]="null">Selecione</mat-option>
                        <mat-option *ngFor="let o of comboUnidades" [value]="o.idUnidade">
                                {{o.nomeUnidade}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlexFill>
                <mat-form-field fxFlex="33%">
                    <mat-label>Turma Secretaria:</mat-label>
                    <mat-select formControlName="matriculaSecretaria" multiple
                                (selectionChange)="onMatriculasSecretariasChange($event.value)"
                                (closed)="limparPesquisaMatriculaSecretaria()">
                        <mat-option>
                            <ngx-mat-select-search ngModel #matriculaSecretariaSearch
                                [ngModelOptions]="{standalone: true}"
                                placeholderLabel="Pesquisar turma..."
                                noEntriesFoundLabel="Nenhuma turma encontrada"
                                [clearSearchInput]="true"
                                (input)="filtrarMatriculasSecretarias(matriculaSecretariaSearch.value)">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option class="acoes-matricula-secretaria">
                            <div class="botoes-selecao-matricula-secretaria">
                                <button type="button" mat-button color="primary"
                                        (click)="$event.stopPropagation(); selecionarTodasMatriculasSecretarias()">
                                    Marcar todos
                                </button>
                                <button type="button" mat-button
                                        (click)="$event.stopPropagation(); desmarcarTodasMatriculasSecretarias()">
                                    Desmarcar todos
                                </button>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let o of matriculasSecretariasFiltradas" [value]="o.id">
                            {{o.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="150px" (click)="exportar()" style="background-color: green; color: white;">
                    EXPORTAR
                </button>

                <button mat-raised-button fxFlex="150px" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="150px" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>
            </div>
        </form>


        <mat-accordion>
            <mat-expansion-panel (opened)="panelBeneficiarioOpenState = true"
                                 (closed)="panelBeneficiarioOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>                  
                    Dados Exportados do Beneficiário
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
        
              <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxFlexFill>
                <section class="example-section" fxFlex="20">
                    <mat-toolbar class="titulopartes">{{getGrupoDadosAluno('dados_pessoais').descricao}}</mat-toolbar>
                    <span class="example-list-section">
                      <mat-checkbox class="example-margin"
                                    [checked]="getGrupoDadosAluno('dados_pessoais').exportar"
                                    [color]="getGrupoDadosAluno('dados_pessoais').exportar ? getGrupoDadosAluno('dados_pessoais').color : 'accent' "
                                    [indeterminate]="someComplete(getGrupoDadosAluno('dados_pessoais'))"
                                    (change)="setAll($event.checked, getGrupoDadosAluno('dados_pessoais'))">
                        {{getGrupoDadosAluno('dados_pessoais').descricao}}
                      </mat-checkbox>
                    </span>
                    <span class="example-list-section">
                      <ul>
                        <li *ngFor="let coluna of getGrupoDadosAluno('dados_pessoais').colunas">
                          <mat-checkbox [(ngModel)]="coluna.exportar"
                                        [color]="coluna.color"
                                        (ngModelChange)="updateAllComplete(getGrupoDadosAluno('dados_pessoais'))">
                            {{coluna.descricao}}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </span>
                </section>
    
    
                <section class="example-section" fxFlex="20">
                    <mat-toolbar class="titulopartes">{{getGrupoDadosAluno('admissao').descricao}}</mat-toolbar>
                    <span class="example-list-section">
                      <mat-checkbox class="example-margin"
                                    [checked]="getGrupoDadosAluno('admissao').exportar"
                                    [color]="getGrupoDadosAluno('admissao').exportar ? getGrupoDadosAluno('admissao').color : 'accent' "
                                    [indeterminate]="someComplete(getGrupoDadosAluno('admissao'))"
                                    (change)="setAll($event.checked, getGrupoDadosAluno('admissao'))">
                        {{getGrupoDadosAluno('admissao').descricao}}
                      </mat-checkbox>
                    </span>
                    <span class="example-list-section">
                      <ul>
                        <li *ngFor="let coluna of getGrupoDadosAluno('admissao').colunas">
                          <mat-checkbox [(ngModel)]="coluna.exportar"
                                        [color]="coluna.color"
                                        (ngModelChange)="onColunaAdmissaoChange()">
                            {{coluna.descricao}}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </span>
                </section>
    
    
                <section class="example-section" fxFlex="20">
                    <mat-toolbar class="titulopartes">{{getGrupoDadosAluno('escolaridade').descricao}}</mat-toolbar>
                    <span class="example-list-section">
                      <mat-checkbox class="example-margin"
                                    [checked]="getGrupoDadosAluno('escolaridade').exportar"
                                    [color]="getGrupoDadosAluno('escolaridade').exportar ? getGrupoDadosAluno('escolaridade').color : 'accent' "
                                    [indeterminate]="someComplete(getGrupoDadosAluno('escolaridade'))"
                                    (change)="setAll($event.checked, getGrupoDadosAluno('escolaridade'))">
                        {{getGrupoDadosAluno('escolaridade').descricao}}
                      </mat-checkbox>
                    </span>
                    <span class="example-list-section">
                      <ul>
                        <li *ngFor="let coluna of getGrupoDadosAluno('escolaridade').colunas">
                          <mat-checkbox [(ngModel)]="coluna.exportar"
                                        [color]="coluna.color"
                                        (ngModelChange)="updateAllComplete(getGrupoDadosAluno('escolaridade'))">
                            {{coluna.descricao}}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </span>
                </section>
    
                <section class="example-section" fxFlex="20">
                    <mat-toolbar class="titulopartes">{{getGrupoDadosAluno('documentos').descricao}}</mat-toolbar>
                    <span class="example-list-section">
                      <mat-checkbox class="example-margin"
                                    [checked]="getGrupoDadosAluno('documentos').exportar"
                                    [color]="getGrupoDadosAluno('documentos').exportar ? getGrupoDadosAluno('documentos').color : 'accent' "
                                    [indeterminate]="someComplete(getGrupoDadosAluno('documentos'))"
                                    (change)="setAll($event.checked, getGrupoDadosAluno('documentos'))">
                        {{getGrupoDadosAluno('documentos').descricao}}
                      </mat-checkbox>
                    </span>
                    <span class="example-list-section">
                      <ul>
                        <li *ngFor="let coluna of getGrupoDadosAluno('documentos').colunas">
                          <mat-checkbox [(ngModel)]="coluna.exportar"
                                        [color]="coluna.color"
                                        (ngModelChange)="updateAllComplete(getGrupoDadosAluno('documentos'))">
                            {{coluna.descricao}}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </span>
                </section>

    
    
                <section class="example-section" fxFlex="20">
                    <mat-toolbar class="titulopartes">{{getGrupoDadosAluno('outras_informacoes').descricao}}</mat-toolbar>
                    <span class="example-list-section">
                      <mat-checkbox class="example-margin"
                                    [checked]="getGrupoDadosAluno('outras_informacoes').exportar"
                                    [color]="getGrupoDadosAluno('outras_informacoes').exportar ? getGrupoDadosAluno('outras_informacoes').color : 'accent' "
                                    [indeterminate]="someComplete(getGrupoDadosAluno('outras_informacoes'))"
                                    (change)="setAll($event.checked, getGrupoDadosAluno('outras_informacoes'))">
                        {{getGrupoDadosAluno('outras_informacoes').descricao}}
                      </mat-checkbox>
                    </span>
                    <span class="example-list-section">
                      <ul>
                        <li *ngFor="let coluna of getGrupoDadosAluno('outras_informacoes').colunas">
                          <mat-checkbox [(ngModel)]="coluna.exportar"
                                        [color]="coluna.color"
                                        (ngModelChange)="updateAllComplete(getGrupoDadosAluno('outras_informacoes'))">
                            {{coluna.descricao}}
                          </mat-checkbox>
                        </li>
                      </ul>
                    </span>
                </section>
            </div>
              
            </mat-expansion-panel>
        </mat-accordion>

        <br/>
        <mat-accordion>
            <mat-expansion-panel (opened)="panelFamiliarOpenState = true"
                                 (closed)="panelFamiliarOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>                  
                        Dados Exportados do Familiar
                    </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
                </mat-expansion-panel-header>

                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxFlexFill>

                    <section class="example-section" fxFlex="18">
                        <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('dados_pessoais').descricao}}</mat-toolbar>
                        <span class="example-list-section">
                        <mat-checkbox class="example-margin"
                                        [checked]="getGrupoDadosFamiliar('dados_pessoais').exportar"
                                        [color]="getGrupoDadosFamiliar('dados_pessoais').exportar ? getGrupoDadosFamiliar('dados_pessoais').color : 'accent' "
                                        [indeterminate]="someComplete(getGrupoDadosFamiliar('dados_pessoais'))"
                                        (change)="setAll($event.checked, getGrupoDadosFamiliar('dados_pessoais'))">
                            {{getGrupoDadosFamiliar('dados_pessoais').descricao}}
                        </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                        <ul>
                            <li *ngFor="let coluna of getGrupoDadosFamiliar('dados_pessoais').colunas">
                            <mat-checkbox [(ngModel)]="coluna.exportar"
                                            [color]="coluna.color"
                                            (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('dados_pessoais'))">
                                {{coluna.descricao}}
                            </mat-checkbox>
                            </li>
                        </ul>
                        </span>
                    </section>


                    <section class="example-section" fxFlex="15">
                        <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('parentesco').descricao}}</mat-toolbar>
                        <span class="example-list-section">
                        <mat-checkbox class="example-margin"
                                        [checked]="getGrupoDadosFamiliar('parentesco').exportar"
                                        [color]="getGrupoDadosFamiliar('parentesco').exportar ? getGrupoDadosFamiliar('parentesco').color : 'accent' "
                                        [indeterminate]="someComplete(getGrupoDadosFamiliar('parentesco'))"
                                        (change)="setAll($event.checked, getGrupoDadosFamiliar('parentesco'))">
                            {{getGrupoDadosFamiliar('parentesco').descricao}}
                        </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                        <ul>
                            <li *ngFor="let coluna of getGrupoDadosFamiliar('parentesco').colunas">
                            <mat-checkbox [(ngModel)]="coluna.exportar"
                                            [color]="coluna.color"
                                            (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('parentesco'))">
                                {{coluna.descricao}}
                            </mat-checkbox>
                            </li>
                        </ul>
                        </span>
                    </section>


                    <div fxLayout="column" fxFlex="15" fxLayoutAlign="start start" fxLayoutGap="20px" fxFlexFill>
                        <section class="example-section" fxFlex="100">
                            <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('responsavel').descricao}}</mat-toolbar>
                            <span class="example-list-section">
                            <mat-checkbox class="example-margin"
                                            [checked]="getGrupoDadosFamiliar('responsavel').exportar"
                                            [color]="getGrupoDadosFamiliar('responsavel').exportar ? getGrupoDadosFamiliar('responsavel').color : 'accent' "
                                            [indeterminate]="someComplete(getGrupoDadosFamiliar('responsavel'))"
                                            (change)="setAll($event.checked, getGrupoDadosFamiliar('responsavel'))">
                                {{getGrupoDadosFamiliar('responsavel').descricao}}
                            </mat-checkbox>
                            </span>
                            <span class="example-list-section">
                            <ul>
                                <li *ngFor="let coluna of getGrupoDadosFamiliar('responsavel').colunas">
                                <mat-checkbox [(ngModel)]="coluna.exportar"
                                                [color]="coluna.color"
                                                (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('responsavel'))">
                                    {{coluna.descricao}}
                                </mat-checkbox>
                                </li>
                            </ul>
                            </span>
                        </section>


                        <section class="example-section" fxFlex="100">
                            <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('escolaridade').descricao}}</mat-toolbar>
                            <span class="example-list-section">
                            <mat-checkbox class="example-margin"
                                            [checked]="getGrupoDadosFamiliar('escolaridade').exportar"
                                            [color]="getGrupoDadosFamiliar('escolaridade').exportar ? getGrupoDadosFamiliar('escolaridade').color : 'accent' "
                                            [indeterminate]="someComplete(getGrupoDadosFamiliar('escolaridade'))"
                                            (change)="setAll($event.checked, getGrupoDadosFamiliar('escolaridade'))">
                                {{getGrupoDadosFamiliar('escolaridade').descricao}}
                            </mat-checkbox>
                            </span>
                            <span class="example-list-section">
                            <ul>
                                <li *ngFor="let coluna of getGrupoDadosFamiliar('escolaridade').colunas">
                                <mat-checkbox [(ngModel)]="coluna.exportar"
                                                [color]="coluna.color"
                                                (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('escolaridade'))">
                                    {{coluna.descricao}}
                                </mat-checkbox>
                                </li>
                            </ul>
                            </span>
                        </section>

                    </div>

                    <section class="example-section" fxFlex="15">
                        <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('documentos').descricao}}</mat-toolbar>
                        <span class="example-list-section">
                        <mat-checkbox class="example-margin"
                                        [checked]="getGrupoDadosFamiliar('documentos').exportar"
                                        [color]="getGrupoDadosFamiliar('documentos').exportar ? getGrupoDadosFamiliar('documentos').color : 'accent' "
                                        [indeterminate]="someComplete(getGrupoDadosFamiliar('documentos'))"
                                        (change)="setAll($event.checked, getGrupoDadosFamiliar('documentos'))">
                            {{getGrupoDadosFamiliar('documentos').descricao}}
                        </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                        <ul>
                            <li *ngFor="let coluna of getGrupoDadosFamiliar('documentos').colunas">
                            <mat-checkbox [(ngModel)]="coluna.exportar"
                                            [color]="coluna.color"
                                            (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('documentos'))">
                                {{coluna.descricao}}
                            </mat-checkbox>
                            </li>
                        </ul>
                        </span>
                    </section>


                    <section class="example-section" fxFlex="15">
                        <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('dados_profissionais').descricao}}</mat-toolbar>
                        <span class="example-list-section">
                        <mat-checkbox class="example-margin"
                                        [checked]="getGrupoDadosFamiliar('dados_profissionais').exportar"
                                        [color]="getGrupoDadosFamiliar('dados_profissionais').exportar ? getGrupoDadosFamiliar('dados_profissionais').color : 'accent' "
                                        [indeterminate]="someComplete(getGrupoDadosFamiliar('dados_profissionais'))"
                                        (change)="setAll($event.checked, getGrupoDadosFamiliar('dados_profissionais'))">
                            {{getGrupoDadosFamiliar('dados_profissionais').descricao}}
                        </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                        <ul>
                            <li *ngFor="let coluna of getGrupoDadosFamiliar('dados_profissionais').colunas">
                            <mat-checkbox [(ngModel)]="coluna.exportar"
                                            [color]="coluna.color"
                                            (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('dados_profissionais'))">
                                {{coluna.descricao}}
                            </mat-checkbox>
                            </li>
                        </ul>
                        </span>
                    </section>
                    

                    <section class="example-section" fxFlex="15">
                        <mat-toolbar class="titulopartes">{{getGrupoDadosFamiliar('outras_informacoes').descricao}}</mat-toolbar>
                        <span class="example-list-section">
                        <mat-checkbox class="example-margin"
                                        [checked]="getGrupoDadosFamiliar('outras_informacoes').exportar"
                                        [color]="getGrupoDadosFamiliar('outras_informacoes').exportar ? getGrupoDadosFamiliar('outras_informacoes').color : 'accent' "
                                        [indeterminate]="someComplete(getGrupoDadosFamiliar('outras_informacoes'))"
                                        (change)="setAll($event.checked, getGrupoDadosFamiliar('outras_informacoes'))">
                            {{getGrupoDadosFamiliar('outras_informacoes').descricao}}
                        </mat-checkbox>
                        </span>
                        <span class="example-list-section">
                        <ul>
                            <li *ngFor="let coluna of getGrupoDadosFamiliar('outras_informacoes').colunas">
                            <mat-checkbox [(ngModel)]="coluna.exportar"
                                            [color]="coluna.color"
                                            (ngModelChange)="updateAllComplete(getGrupoDadosFamiliar('outras_informacoes'))">
                                {{coluna.descricao}}
                            </mat-checkbox>
                            </li>
                        </ul>
                        </span>
                    </section>                
                    
                </div>
            </mat-expansion-panel>
        </mat-accordion>





        <div [hidden]="!mostrarTabela" style="margin-top: 20px;">
            <mat-paginator #paginator [pageSizeOptions]="[50, 100, 150, 200, 300]" showFirstLastButtons></mat-paginator>
        </div>
        <table [fxHide]="!mostrarTabela" 
                matSort matSortDisableClear mat-table [dataSource]="dataSource">
                
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 20px">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="matricula" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 50px">Matrícula</th>
                <td mat-cell *matCellDef="let element"> {{element.matricula }} </td>
            </ng-container>

            <ng-container matColumnDef="beneficiario" >
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Beneficiário</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeBeneficiario }} </td>
            </ng-container>

            <ng-container matColumnDef="turmaSecretaria">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Turma Secretaria</th>
                <td mat-cell *matCellDef="let element"> {{element.turmaSecretaria }} </td>
            </ng-container>

            <ng-container matColumnDef="nomeMae">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Mãe</th>
                <td mat-cell *matCellDef="let element"> {{element.nomeMae }} </td>
            </ng-container>

            <ng-container matColumnDef="nomePai">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Pai</th>
                <td mat-cell *matCellDef="let element"> {{element.nomePai }} </td>
            </ng-container>

            <ng-container matColumnDef="unidade">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: center; width: 200px">Unidade</th>
                <td mat-cell *matCellDef="let element"> {{element.unidade }} </td>
            </ng-container>            

            <ng-container matColumnDef="dataEntrada">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Entrada</th>
                <td mat-cell *matCellDef="let element"> {{element.dataEntrada | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="dataDesligamento">
                <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80px"> Data Desligamento</th>
                <td mat-cell *matCellDef="let element"> {{element.dataDesligamento | dataSimples }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator (page)="handlePageBottom($event)" 
                            [pageSize]="paginator.pageSize"
                            [pageIndex]="paginator.pageIndex" 
                            [length]="paginator.length"
                            [pageSizeOptions]="paginator.pageSizeOptions">
            </mat-paginator>
        </div>
        
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px"
                [fxHide]="mostrarTabela" >
            {{msg}}
        </div>       

    </div>
</div>
